import { Action, Dispatch } from 'redux';
import { IAppState } from '../reducers';
import { selectUserOrgsSecurityProfiles } from '../../state/user/userOrgRole';
import { updateSecurityProfile } from '../../api/vault/securityProfiles/api';
import { updateSecurityProfile as updateLocalSecurityProfile } from '../../state/securityProfiles';

export interface IState {
  isOpen: boolean;
  isLoading: boolean;
  isLoaded: boolean;
  manualDownloadPriority: boolean;
}

export enum ActionType {
  Toggle = 'DownloadPriority.Toggle',
  StartLoading = 'DownloadPriority.StartLoad',
  FinishLoading = 'DownloadPriority.FinishLoad',
  UpdatePriority = 'DownloadPriority.UpdatePriority',
  Clear = 'DownloadPriority.Clear',
}
export interface IDownloadPriorityAction extends Action<ActionType> {
  payload?: any,
}

const INITIAL_STATE: IState = {
  isOpen: false,
  isLoading: false,
  isLoaded: false,
  manualDownloadPriority: false,
};

export default function reducer(state: IState = INITIAL_STATE, action: IDownloadPriorityAction): IState {
  switch (action.type) {
    case ActionType.Toggle:
      return {
        ...state,
        isOpen: !state.isOpen,
      };
    case ActionType.StartLoading:
      return {
        ...state,
        isLoading: true,
      };
    case ActionType.FinishLoading:
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
      };
    case ActionType.UpdatePriority:
      return {
        ...state,
        manualDownloadPriority: action.payload.manualDownloadPriority,
      };
    case ActionType.Clear:
      return INITIAL_STATE;
    default:
      return state;
  }
}

export const toggleDownloadPriority = () => async (
  dispatch: Dispatch,
  getState: () => IAppState,
) => {
  dispatch({
    type: ActionType.Toggle,
  });
};

export const fetchDownloadPriority = () => async (
  dispatch: Dispatch,
  getState: () => IAppState,
) => {
  const state = getState();

  dispatch({
    type: ActionType.StartLoading,
  });

  const [{ manual_download_priority }] = selectUserOrgsSecurityProfiles(state);

  dispatch({
    type: ActionType.UpdatePriority,
    payload: { manualDownloadPriority: manual_download_priority },
  });

  dispatch({
    type: ActionType.FinishLoading,
  });
};

export const clearDownloadPriority = () => ({
  type: ActionType.Clear,
});

export const updateManualDownloadPriority = (manualDownloadPriority: boolean) => ({
  type: ActionType.UpdatePriority,
  payload: {
    manualDownloadPriority,
  },
});

export const saveDownloadPriority = () => async (
  dispatch: Dispatch<any>,
  getState: () => IAppState,
) => {
  const state = getState();
  const { exchange: { downloadPriority: { manualDownloadPriority } } } = state;

  const [securityProfile] = selectUserOrgsSecurityProfiles(state);
  const { _id } = securityProfile;

  const { status } = await updateSecurityProfile(_id, {
    manual_download_priority: manualDownloadPriority,
  });

  if (status !== 200) {
    console.error(`[QA]: Could not save security profile "${_id}"`);
  } else {
    dispatch(updateLocalSecurityProfile({
      ...securityProfile,
      manual_download_priority: manualDownloadPriority,
    }));
  }
};
